import { Badge, Dropdown, Icon, Menu } from 'antd'
import useFetch from 'elements/Hooks/useFetch'
import { GlobalContext } from 'Global'
import Authentication from 'modules/Authentication'
import { handleErrors, handleResponse } from 'modules/Utils'
import React, { useState, useEffect } from 'react'
import moment from 'moment'
import { apiUrl } from 'variables'
import { useHistory } from 'react-router-dom'

export default function Notification() {
  const { primaryColor } = React.useContext(GlobalContext)
  const auth = new Authentication()
  let history = useHistory()

  const { data: notifications = [], fetching: fetchingNotifications, fetch: fetchNotifications } = useFetch({
    url: 'notification/owner',
  })

  const [tick, setTick] = useState(0)
  useEffect(() => {
    const interval = setInterval(() => {
      if (!fetchingNotifications) setTick((e) => e + 1)
    }, 1000 * 60 * 5)
    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    fetchNotifications()
  }, [tick])

  async function onOpen(i) {
    console.log('in')
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `Bearer ${auth.getAccessToken()}`,
    }
    fetch(`${apiUrl}notification/${i._key}`, { headers }).then(handleErrors).then(handleResponse)
    fetchNotifications()
    history.replace(i.url)
  }

  const menu = notifications ? (
    <Menu>
      {notifications.map((i) => (
        <Menu.Item key="0" onClick={() => onOpen(i)}>
          <div className="flex-grow">
            <div>
              <span className="text-base font-medium text-gray-900">{i.title}</span>
              <span className="text-sm mx-2 text-gray-500">{i.subtitle}.</span>
              <span className="bg-red-200">
                {!i.isSeen && (
                  <Icon style={{ fontSize: 14, color: '#ff0053', float: 'right' }} type="exclamation-circle" />
                )}
              </span>
            </div>
            <p className="text-xs p-0 text-gray-500">{moment(i.date).fromNow()}.</p>
          </div>
        </Menu.Item>
      ))}
    </Menu>
  ) : null

  return (
    <Dropdown overlay={menu} disabled={notifications.length === 0}>
      <Badge size="small" count={notifications.filter((i) => !i.isSeen).length}>
        <button className={`m-2 text-${primaryColor}-400 hover:text-${primaryColor}-200`}>
          <svg className="h-5 w-5 stroke-current" viewBox="0 0 20 20">
            <path d="M14.38,3.467l0.232-0.633c0.086-0.226-0.031-0.477-0.264-0.559c-0.229-0.081-0.48,0.033-0.562,0.262l-0.234,0.631C10.695,2.38,7.648,3.89,6.616,6.689l-1.447,3.93l-2.664,1.227c-0.354,0.166-0.337,0.672,0.035,0.805l4.811,1.729c-0.19,1.119,0.445,2.25,1.561,2.65c1.119,0.402,2.341-0.059,2.923-1.039l4.811,1.73c0,0.002,0.002,0.002,0.002,0.002c0.23,0.082,0.484-0.033,0.568-0.262c0.049-0.129,0.029-0.266-0.041-0.377l-1.219-2.586l1.447-3.932C18.435,7.768,17.085,4.676,14.38,3.467 M9.215,16.211c-0.658-0.234-1.054-0.869-1.014-1.523l2.784,0.998C10.588,16.215,9.871,16.447,9.215,16.211 M16.573,10.27l-1.51,4.1c-0.041,0.107-0.037,0.227,0.012,0.33l0.871,1.844l-4.184-1.506l-3.734-1.342l-4.185-1.504l1.864-0.857c0.104-0.049,0.188-0.139,0.229-0.248l1.51-4.098c0.916-2.487,3.708-3.773,6.222-2.868C16.187,5.024,17.489,7.783,16.573,10.27" />
          </svg>
        </button>
      </Badge>
    </Dropdown>
  )
}
